import React from 'react'
import { moneyFormatter } from '@dostavkee/helpers'
import clsx from 'clsx'
import dayjs from 'dayjs'

import { Button } from '../button/button'
import { IconInvoice } from '../icon'
import styles from './transaction-item.module.scss'

export interface TransactionItemProps {
    date: string | Date
    message: string | React.ReactNode
    amount: number
    commission?: string | number
    receipt_url?: string
    variant?: 'payment' | 'income'
    card?: string
}

const SYMBOL_MAP = {
    payment: '-',
    income: '+',
}

export const TransactionItem: React.FC<TransactionItemProps> = ({
    date,
    message,
    amount,
    commission,
    variant = 'payment',
    card,
    receipt_url,
}) => {
    return (
        <div className={styles['transaction-item']}>
            <div className={styles['transaction-item__content']}>
                <div>
                    <div className={styles['transaction-item__subtext']}>
                        {dayjs(date).format('DD.MM.YYYY, HH:mm')}
                    </div>
                    <div className={styles['transaction-item__text']}>{message}</div>
                    {commission && (
                        <div className={styles['transaction-item__subtext']}>
                            Агентское вознаграждение
                        </div>
                    )}
                </div>
                <div>
                    {card && <div className={styles['transaction-item__subtext']}>{card}</div>}
                    <div
                        className={clsx([
                            styles['transaction-item__text'],
                            styles[`transaction-item__text--${variant}`],
                        ])}
                    >
                        {SYMBOL_MAP[variant]}
                        {moneyFormatter(amount)}
                    </div>
                    {commission && (
                        <div className={styles['transaction-item__subtext']}>{commission}%</div>
                    )}
                </div>
            </div>
            {receipt_url && (
                <div className={styles['transaction-item__footer']}>
                    <Button
                        isText
                        color='accent'
                        postfixEl={<IconInvoice color='var(--text-and-icon-accent)' size={20} />}
                        variant='ghost'
                        onClick={(event) => {
                            event.preventDefault()
                            event.stopPropagation()
                            window.open(receipt_url, '_blank', 'noopener,noreferrer')
                        }}
                    >
                        Показать чек
                    </Button>
                </div>
            )}
        </div>
    )
}
